/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { useState } from 'react';
import { DataContext } from '../contexts/DataContext';

const DataProvider = props => {
  const [currentFlowIdentifier, setCurrentFlowIdentifier] = useState('');
  const [selectedLocationIndex, setSelectedLocationIndex] = useState();

  return (
    <DataContext.Provider
      value={{
        currentFlowIdentifier,
        setCurrentFlowIdentifier,
        selectedLocationIndex,
        setSelectedLocationIndex
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataProvider;
